import React from 'react'

function BasicInfoSection({itemDatas,txtColor,iconColor}) {
    return (
        <div>
            <div className="grid-cols-2 gap-4 mt-5 grid justify-center" >
                {itemDatas.map((item, index) => (
                    <div
                        key={index}
                        style={{color:txtColor}}
                        className={`grid justify-items-center ${itemDatas.length % 2 !== 0 && (index === itemDatas.length - 1)
                            ? 'col-span-2'
                            : ''
                            }`}
                    >
                        <div
                            className="w-14 "
                            style={{color:iconColor}}
                            dangerouslySetInnerHTML={{ __html: item?.svgId.svg }}
                        />
                        <p className=" font-semibold text-sm mt-2 ">{item?.tittle}</p>
                        <p className=" font-normal text-sm mt-3 text-center">
                            {item?.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BasicInfoSection